module.exports = __webpack_public_path__ + "img/prop_v2.de395a5.png";